import {
  ADD_INTEREST_REQUEST,
  ADD_INTEREST_SUCCESS,
  ADD_INTEREST_FAILURE,
  UPDATE_INTEREST_REQUEST,
  UPDATE_INTEREST_SUCCESS,
  UPDATE_INTEREST_FAILURE,
  GET_INTEREST_REQUEST,
  GET_INTEREST_SUCCESS,
  GET_INTEREST_FAILURE,
  DELETE_INTEREST_REQUEST,
  DELETE_INTEREST_SUCCESS,
  DELETE_INTEREST_FAILURE,
} from "../constants/interestConstant";

const interestInitialState = {
  interest: null,
  interestList: [],
  loading: false,
  error: null,
};

export const interestReducer = (state = interestInitialState, action) => {
  switch (action.type) {
    case ADD_INTEREST_REQUEST:
      return { ...state, loading: true, error: null };
    case ADD_INTEREST_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case ADD_INTEREST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_INTEREST_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_INTEREST_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case UPDATE_INTEREST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_INTEREST_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_INTEREST_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case DELETE_INTEREST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_INTEREST_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_INTEREST_SUCCESS:
      return { ...state, loading: false, package: action.payload };
    case GET_INTEREST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
